<div class="drag-scroll-content" #contentRef>
	<ng-content></ng-content>
</div>
